module.exports = __webpack_public_path__ + "static/media/IntroToFigma.ce479e8b.png";